module.exports = "/wwwroot/img/water_payment_calculator_page.png?ver=1345cbe2";